import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "data-usage-container elevate" }
const _hoisted_2 = { class: "data-usage-top" }
const _hoisted_3 = { style: {"margin":"0"} }
const _hoisted_4 = { style: {"color":"red"} }
const _hoisted_5 = { class: "data-usage-bars" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"45px","width":"100%"} }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  href: "#",
  style: {"color":"red"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("dataUsage.title")), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.storageSpaceRemaining < 0
					? _ctx.$t("dataUsage.overCapacity")
					: _ctx.formatBytes(_ctx.storageSpaceRemaining) + " " + _ctx.$t("dataUsage.remaining")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
        return (_openBlock(), _createBlock(_component_imdex_tooltip, {
          nudgeY: -10,
          class: "data-usage-bar",
          key: i,
          style: _normalizeStyle(`background:${item.color}; flex:${item.size / _ctx.containerSize}`)
        }, _createSlots({ _: 2 }, [
          (item.size && item.size != 0)
            ? {
                name: "activator",
                fn: _withCtx((on) => [
                  _createElementVNode("div", _mergeProps(_toHandlers(on), { style: {"width":"100%","height":"100%"} }), _hoisted_7, 16)
                ])
              }
            : undefined,
          (item.size && item.size != 0)
            ? {
                name: "tooltip",
                fn: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: `${item.name} - ${_ctx.formatBytes(item.size)}`
                  }, null, 8, _hoisted_8)
                ])
              }
            : undefined
        ]), 1032, ["style"]))
      }), 128))
    ]),
    _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.$t("dataUsage.getMoreSpace")), 1)
  ]))
}